export default [
//[lang, emoji, name, isAvaiable]
  ['ar', '🇦🇪', 'Arabic'],
  ['zh-cn', '🇨🇳', 'Chinese'],
  ['fr', '🇫🇷', 'French'],
  ['ru', '🇷🇺', 'Russian', true],
  ['es', '🇪🇸', 'Spanish'],
];
